import { useRouteError } from "react-router";

export function ErrorPage() {
  const error = useRouteError() as Record<string, never>;

  return (
    <div>
      <h1>糟糕!</h1>
      <p>发生了意料之外的错误</p>
      <p>
        <i>{error?.statusText || error?.message}</i>
      </p>
    </div>
  );
}
